// api/accountingDashboardAPI.js
import axiosInstance from './axiosConfig';

const accountingDashboardAPI = {
  /**
   * GET /api/accounting/dashboard-summary
   * @param {Object} params - { accountingClient, fiscalYear }
   * @returns {{ fiscalYear, monthlyIncome, balanceSnapshot, arOutstanding, apOutstanding }}
   */
  getDashboardSummary: async (params = {}) => {
    try {
      const response = await axiosInstance.get('/accounting/dashboard-summary', { params });
      return response.data;
    } catch (error) {
      console.error('Accounting Dashboard API Error:', error.response?.data || error.message);
      throw error.response?.data?.message || 'Failed to fetch accounting dashboard data';
    }
  },
};

export default accountingDashboardAPI;
